import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayoutColumn: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconLayoutColumn"><Path d="M3 21V3H11.25V21L3 21Z" fill="currentColor"/><Path d="M12.75 21L21 21V3H12.75V21Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLayoutColumn;
